<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'App',
  created: function () {
    this.fnResize()
    $(window).resize(this.onResizeWindow)
  },
  methods: {
    onResizeWindow: function () {
      this.fnResize()
    },
    fnResize: function () {
      var deviceWidth = $(window).width()
      var fp = 16
      if (deviceWidth > 1920) {
        fp = 16
      } else if (deviceWidth > 1280) {
        fp = 12
      } else {
        // fp = 8
        fp = deviceWidth / 1920 * 16
      }
      $('html').css({'font-size': fp + 'px'})
      // var deviceWidth = $(window).width()
      // var fp = deviceWidth / 1280 * 16
      // $('html').css({'font-size': fp + 'px'})
    }
  }
}
</script>

<style>
  body{
    overflow-y: hidden;
    overflow-x:hidden;
    margin: 0!important;
  }
#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  box-sizing: border-box;
  /*background-image: linear-gradient(135deg,  #77CEE1,#E1F9FB);*/
  background-color: #8a888c;
}
</style>



// WEBPACK FOOTER //
// src/App.vue